import {
  RemoteMultiFilterDropdown,
  ReporterFilterMenu,
  ProductFilterMenu,
  AdverseEventFilterMenu,
  SourceFilterMenu,
  DateFilter,
} from './FilterDropdowns';

export const filterTypes = {
  remoteMultiFilter: {
    component: RemoteMultiFilterDropdown,
  },
  reporterFilter: {
    component: ReporterFilterMenu,
  },
  productFilter: {
    component: ProductFilterMenu,
  },
  aeFilter: {
    component: AdverseEventFilterMenu,
  },
  sourceFilter: {
    component: SourceFilterMenu,
  },
  dateFilter: {
    component: DateFilter,
  },
};



// WEBPACK FOOTER //
// ./src/Components/FilterTypeConfig.js